<div class="row">
  <div class="col-md-6 col-xl-4">
    <form [formGroup]="inputListForm">
      <select aria-label="IdListInputDropdown" class="form-select" formControlName="inputTypeControl"
        data-cy="IdListInputDropdown" [(ngModel)]="selectedInputType">
        @for (inputType of inputTypeList; track inputType) {
          <option [ngValue]="inputType"
            [attr.data-cy]="inputType.text">
            {{inputType.text}}
          </option>
        }
      </select>
      <textarea class="form-control mt-3" formControlName="rawInputControl"
        placeholder="Input one item per line, then click Validate">
      </textarea>
      <div class="mt-3 text-end">
        <button class="btn btn-info btn-sm" (click)="validate()" data-cy="ValidateButton">
          Validate
        </button>
      </div>
    </form>
  </div>
  <div class="col-md-6 col-xl-8">
    <rl-input-list-results [results]="results"></rl-input-list-results>
  </div>
</div>